var card_content_default = {
  "content": "e7uS-",
  "textStart": "RKCHs",
  "contentText": "fnb5Q",
  "subtitle": "D2ZAr",
  "pricing": "_5UXFP",
  "titlePriceContainer": "EDa0D",
  "textCenter": "_1Oc0H",
  "textEnd": "pWmOR",
  "titlePriceSideBySide": "_7jOVu",
  "titlePriceStacked": "tWRz2",
  "title": "x2tPi",
  "price": "mYBOX",
  "priceDiscounted": "_3O8jU",
  "priceOriginal": "fEXZU",
  "priceStrikethrough": "Rcua4",
  "ribbon": "_041Mn",
  "button": "_5-8pw",
  "button_disabled": "VLQXX",
  "buttonText": "lxfrp",
  "framelessContent": "PPkvx",
  "framelessImageTop": "yppZ6",
  "framelessImageStart": "PKBqR",
  "framelessImageEnd": "VZvN9"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
